import Title from 'common/data-display/Title';
import Card from 'components/common/Card';
import Button from 'components/common/buttons/Button';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchLinhasPesquisa } from 'services/core';
import styled from 'styled-components';

const LinhaPesquisaPage = ({ className }) => {
  const [linhaPesquisa, setLinhaPesquisa] = useState([]);

  const history = useHistory();

  useEffect(() => {
    if (linhaPesquisa.length == 0) {
      fetchLinhasPesquisa().then((res) => setLinhaPesquisa(res));
    }
  }, []);

  return (
    <Card className={className}>
      <div className="title">
        <Title title="Lista de Linhas de Pesquisa" />
        <Link className="btn btn-primary" to={`/linhas-pesquisa/new`}>
          CADASTRAR LINHA DE PESQUISA
        </Link>
      </div>
      {linhaPesquisa ? (
        linhaPesquisa.map((lp) => {
          return (
            <div
              onClick={() => history.push(`/linhas-pesquisa/${lp.id}/edit`)}
              className="card-link"
            >
              <p className="semi-bold brown">
                Nome:{' '}
                <span className="ml-1" style={{ color: '#313131' }}>
                  {lp.nome}
                </span>
              </p>
            </div>
          );
        })
      ) : (
        <>
          <label>Não existem Linhas de Pesquisa cadastradas.</label>
        </>
      )}
    </Card>
  );
};

export default styled(LinhaPesquisaPage)`
  .title {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .card-link {
    width: 100%;
    height: 50px;
    padding: 10px;
    border: 3px solid #F5F5F5FF;
    display: flex;
    border-radius: 5px;
    align-items: center;
    cursor: pointer;
  }
`;
